import {Link, Route} from 'react-router-dom';
import React from 'react';
import AuthMiddleware from '../middleware/AuthMiddleware';
import {useSelector} from "react-redux";
import {checkPermission} from "./RouteValidator";
import AddSale from '../../modules/sale/AddSale';
import ManageSales from '../../modules/sale/ManageSales';
import UpdateSale from '../../modules/sale/UpdateSale';
import AddCreditNote from '../../modules/sale/AddCreditNote';
import ManageCreditNotes from '../../modules/sale/ManageCreditNote';
import UpdateCreditNote from '../../modules/sale/UpdateCreditNote';
import SaleInvoice from "../../modules/sale/SaleInvoice";

const GenerateSalesModuleRoutes = () => {
    const company = useSelector((state: any) => state.company);
    const auth = useSelector((state: any) => state.auth);

    const routes: any = [];

    // Sales
    if (checkPermission(auth, company, '/sales/add')) {
        routes.push(
            <Route path={'/sales/add'} element={
                <AuthMiddleware children={<AddSale/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/sales')) {
        routes.push(
            <Route path={'/sales'} element={
                <AuthMiddleware children={<ManageSales/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/sales/details/id')) {
        routes.push(
            <Route path={'/sales/details/:id'} element={
                <AuthMiddleware children={<UpdateSale/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/sales/details/id')) {
        routes.push(
            <Route path={'/sales/details/:id/invoice'} element={
                <SaleInvoice/>
            }/>
        );
    }

    // Credit Note
    if (checkPermission(auth, company, '/credit-notes/add')) {
        routes.push(
            <Route path={'/credit-notes/add'} element={
                <AuthMiddleware children={<AddCreditNote/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/credit-notes')) {
        routes.push(
            <Route path={'/credit-notes'} element={
                <AuthMiddleware children={<ManageCreditNotes/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/credit-notes/details/id')) {
        routes.push(
            <Route path={'/credit-notes/details/:id'} element={
                <AuthMiddleware children={<UpdateCreditNote/>}/>
            }/>
        );
    }


    return routes;
}

export default GenerateSalesModuleRoutes;
